import { render, staticRenderFns } from "./DeudaReport.vue?vue&type=template&id=72c9d620&scoped=true"
import script from "./DeudaReport.vue?vue&type=script&lang=js"
export * from "./DeudaReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c9d620",
  null
  
)

export default component.exports